// @ts-nocheck
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsProductCustomMessageStyles {
    container?: GridContainerProps;
    productCustomMessageGridItem?: GridItemProps;
    productCustomMessageInfosBox?: InfosBoxProps;
}

export const productCustomMessageStyles: ProductDetailsProductCustomMessageStyles = {
    container: {
        gap: 0,
        offsetCss: css`
            max-width: 100%;
        `,
    },
    productCustomMessageGridItem: {
        width: 12,
    },
    productCustomMessageInfosBox: { type: "info" },
};

const ProductDetailsProductCustomMessage: React.FC<Props> = ({ product }) => {
    if (!product || !product.properties.productCustomMessage) {
        return null;
    }

    return (
        <GridContainer {...productCustomMessageStyles.container}>
            <GridItem {...productCustomMessageStyles.productCustomMessageGridItem}>
                <InfosBox {...productCustomMessageStyles.productCustomMessageInfosBox}>
                    {product.properties.productCustomMessage}
                </InfosBox>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsProductCustomMessage),
    definition: {
        displayName: "Product Custom Message",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
